import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function KarmaRequestList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "requested_for", sortable: false, label: "User" },
        { key: "date", sortable: false, label: "Date" },
        { key: "karma_catalog.karma_category", sortable: false, label: "Category" },
        // { key: "karma_catalog.sub_karma_category", sortable: false, label: "Sub Category" },
        { key: "karma_catalog_id", sortable: false, label: "Karma Catalog" },
        { key: "karma_point", sortable: false, label: "Point" },
        { key: "status", sortable: false, label: "Status" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalKarmaRequestList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(['approval_pending','partially_approved']);
    const karmaRequestsMetaData = ref([]);
    const karmaRequestStatusOption = ref([]);
    const categoryFilter = ref(null);
    const parentCategoryOption = ref([]);
    const karmaProgramFilter = ref(null);
    const karmaProgramOption = ref([]);
    const dateFilter = ref(null);
    const managerFilter = ref(null);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalKarmaRequestList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [
            currentPage,
            perPage,
            searchQuery,
            statusFilter,
            categoryFilter,
            karmaProgramFilter,
            dateFilter,
            managerFilter,
        ],
        () => {
            refetchData();
        }
    );

    const fetchKarmaRequestList = (ctx, callback) => {
        store
            .dispatch("app-karma-requests/fetchKarmaRequests", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
                categoryFilter: categoryFilter.value,
                karmaProgramFilter: karmaProgramFilter.value,
                dateFilter: dateFilter.value,
                managerFilter: managerFilter.value,
            })
            .then(response => {
                const karma_request = response.data.data;
                const { total } = response.data.meta;
                karmaRequestStatusOption.value = response.data.status;
                parentCategoryOption.value = response.data.parent_category_option;
                karmaProgramOption.value = response.data.karma_program_option;

                callback(karma_request);
                totalKarmaRequestList.value = total;
                karmaRequestsMetaData.value = karma_request;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching karma-requests",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });
                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching karma-requests`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == 'rejected') return "danger";
        if (status == 'approval_pending') return "warning";
        if (status == 'partially_approved') return "warning";
        if (status == 'approved') return "success";
        return "warning";
    };

    return {
        fetchKarmaRequestList,
        tableColumns,
        perPage,
        currentPage,
        totalKarmaRequestList,
        karmaRequestsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        karmaRequestStatusOption,
        statusFilter,
        categoryFilter,
        parentCategoryOption,
        karmaProgramFilter,
        karmaProgramOption,
        dateFilter,
        managerFilter
    };
}
